'use client';
/* eslint-disable i18next/no-literal-string */
/* eslint-disable @next/next/no-html-link-for-pages */
import { useEffect } from 'react';

// @TODO: This is displayed like a 404 for now, since we have a bug preventing true 404s.
// This will be fixed in Next.JS 16.3, and we can then change this content back to generic error content.
// It should be as static as possible without requiring any library imports.
const GlobalError = ({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    if (globalThis.window) {
      if (!globalThis.window.dataLayer) {
        globalThis.window.dataLayer = [];
      }
      globalThis.window.dataLayer.push({
        event: 'error_message',
        message: error.digest || error.message,
      });
    }
  }, []);

  return (
    <html lang="en">
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex" />
        {}
        <link
          rel="preload"
          href="https://www.compassion.com/_next/static/media/NeighbourSans_Medium-s.p.047rll8tr99~z.woff2"
          as="font"
          crossOrigin=""
          type="font/woff2"
        />
      </head>
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif' }}>
        <main
          style={{
            display: 'flex',
            minHeight: '100vh',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '96px 24px',
            backgroundColor: '#fff',
          }}
        >
          <section style={{ width: '100%', maxWidth: '640px' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxWidth: '448px',
                margin: '0 auto',
                alignItems: 'center',
                textAlign: 'center',
                gap: '16px',
              }}
            >
              <h1
                style={{
                  fontSize: '2rem',
                  fontWeight: 700,
                  margin: 0,
                  color: '#1a1a1a',
                }}
              >
                Uh oh, we can&#39;t find that page...
              </h1>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#4a4a4a',
                  margin: 0,
                  lineHeight: 1.5,
                }}
              >
                Sorry, the page you are looking for doesn&#39;t exist or has
                been moved.
              </p>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                gap: '24px',
                marginTop: '48px',
              }}
            >
              {/* Card: Explore Compassion */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  textAlign: 'left',
                }}
              >
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  style={{ flexShrink: 0 }}
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="#005eb8"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 8v4l3 3"
                    stroke="#005eb8"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <h2
                  style={{
                    fontSize: '1rem',
                    fontWeight: 600,
                    margin: 0,
                    color: '#1a1a1a',
                  }}
                >
                  Explore Compassion
                </h2>
                <p
                  style={{
                    fontSize: '0.875rem',
                    color: '#4a4a4a',
                    margin: 0,
                    lineHeight: 1.5,
                  }}
                >
                  You can make a life-changing difference by sponsoring a child
                  who is waiting for someone like you.
                </p>
                <a
                  href="/sponsor-a-child/"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 20px',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    color: '#fff',
                    backgroundColor: '#005eb8',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    alignSelf: 'flex-start',
                  }}
                >
                  Sponsor a child
                </a>
              </div>

              {/* Card: Not sure where to start? */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  textAlign: 'left',
                }}
              >
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  style={{ flexShrink: 0 }}
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="7"
                    stroke="#005eb8"
                    strokeWidth="2"
                  />
                  <path
                    d="M16.5 16.5L21 21"
                    stroke="#005eb8"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <h2
                  style={{
                    fontSize: '1rem',
                    fontWeight: 600,
                    margin: 0,
                    color: '#1a1a1a',
                  }}
                >
                  Not sure where to start?
                </h2>
                <p
                  style={{
                    fontSize: '0.875rem',
                    color: '#4a4a4a',
                    margin: 0,
                    lineHeight: 1.5,
                  }}
                >
                  Search our site to learn more about Compassion&#39;s mission,
                  explore ways to get involved, or find the answers you need.
                </p>
                <a
                  href="/search/"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 20px',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    color: '#fff',
                    backgroundColor: '#005eb8',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    alignSelf: 'flex-start',
                  }}
                >
                  Search
                </a>
              </div>

              {/* Card: Get in touch */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  textAlign: 'left',
                }}
              >
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z"
                    stroke="#005eb8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h2
                  style={{
                    fontSize: '1rem',
                    fontWeight: 600,
                    margin: 0,
                    color: '#1a1a1a',
                  }}
                >
                  Get in touch
                </h2>
                <p
                  style={{
                    fontSize: '0.875rem',
                    color: '#4a4a4a',
                    margin: 0,
                    lineHeight: 1.5,
                  }}
                >
                  If you can&#39;t find the information you&#39;re looking for
                  or need further assistance, don&#39;t hesitate to reach out to
                  us.
                </p>
                <a
                  href="/about-us/contact/"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 20px',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    color: '#fff',
                    backgroundColor: '#005eb8',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    alignSelf: 'flex-start',
                  }}
                >
                  Contact us
                </a>
              </div>
            </div>
          </section>
        </main>
      </body>
    </html>
  );
};

export default GlobalError;
